import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { UIBetSettingsType, UIDenomDisplayType } from "gameiom/wrapper/wrapper-data";

export function setupSharedI18N() {
    Services.get(TranslationsService).setAlias("jak.spn", "free_spins_remaining");
    Services.get(TranslationsService).setAlias("jak.val", "free_spins_count");
    Services.get(TranslationsService).setAlias("mc.sym", "mc_symbols_collected");
    Services.get(TranslationsService).setAlias("sym.col", "collected_label");
    Services.get(TranslationsService).setAlias("mc.col", "collect");
    Services.get(TranslationsService).setAlias("mc.win", "to_win");
    Services.get(TranslationsService).setAlias("bet.up", "bet_up");
    Services.get(TranslationsService).setAlias("for.more", "for_more");
    Services.get(TranslationsService).setAlias("fot.gam", "wins_x_credits");
    Services.get(TranslationsService).setAlias("fot.bon", "you_won_x_credits");
    Services.get(TranslationsService).setAlias("fot.way", "ways_win");
    Services.get(TranslationsService).setAlias("fot.ways", "multiways_win");
    Services.get(TranslationsService).setAlias("fot.tri", "freespins_win");
    Services.get(TranslationsService).setAlias("fot.trs", "freespins_win");
    Services.get(TranslationsService).setAlias("fot.new", "adjust_bet");
    Services.get(TranslationsService).setAlias("fot.fs", "free_spins_won");
    Services.get(TranslationsService).setAlias("fot.no", "adjust_bet");
    Services.get(TranslationsService).setAlias("fot.pla", "good_luck");
    Services.get(TranslationsService).setAlias("fot.fpl", "freespins_caps");
    Services.get(TranslationsService).setAlias("bar.xoy", "free_spins_count");
    Services.get(TranslationsService).setAlias("sound_prompt", "sound_prompt");
    Services.get(TranslationsService).setAlias("yes", "yes");
    Services.get(TranslationsService).setAlias("no", "no");
    Services.get(TranslationsService).setAlias("err.bal", "balance_too_low");
    Services.get(TranslationsService).setAlias("err.dis", "internet_disconnected");
    Services.get(TranslationsService).setAlias("rec.fre", "recovered");
    Services.get(TranslationsService).setAlias("rec.spi", "recovered");
    Services.get(TranslationsService).setAlias("sou.loa", "load_sounds");
    Services.get(TranslationsService).setAlias("aut.swl", "single_win_limit");
    Services.get(TranslationsService).setAlias("aut.lol", "loss_limit");
    Services.get(TranslationsService).setAlias("aut.twl", "total_win_limit");
    Services.get(TranslationsService).setAlias("aut.dis", "");
    Services.get(TranslationsService).setAlias("aut.sto", "stop_autoplay");
    Services.get(TranslationsService).setAlias("aut.spn", "auto_spins");
    Services.get(TranslationsService).setAlias("lbl.oaw", "on_any_win");
    Services.get(TranslationsService).setAlias("lbl.onn", "on");
    Services.get(TranslationsService).setAlias("lbl.off", "off");
    Services.get(TranslationsService).setAlias("lbl.fiw", "if_feature_is_won");
    Services.get(TranslationsService).setAlias("lbl.swe", "if_single_win");
    Services.get(TranslationsService).setAlias("lbl.twe", "if_total_win");
    Services.get(TranslationsService).setAlias("lbl.tlr", "if_total_loss");
    Services.get(TranslationsService).setAlias("btn.sta", "start");
    Services.get(TranslationsService).setAlias("btn.qui", "quit_game");
    Services.get(TranslationsService).setAlias("btn.gnrc", "btn_generic");
    Services.get(TranslationsService).setAlias("btn.his", "hist_label");
    Services.get(TranslationsService).setAlias("btn.btg", "back_to_game");
    Services.get(TranslationsService).setAlias("bon.mwj", "pick_text");
    Services.get(TranslationsService).setAlias("pmt.mjw", "major_progressive_won");
    Services.get(TranslationsService).setAlias("pmt.grw", "grand_progressive_won");
    Services.get(TranslationsService).setAlias("pmt.mnw", "minor_progressive_won");
    Services.get(TranslationsService).setAlias("pmt.miw", "mini_progressive_won");
    Services.get(TranslationsService).setAlias("lbl.exp", "bonanza_blast_feature");
    Services.get(TranslationsService).setAlias("lbl.wil", "wild_feature");
    Services.get(TranslationsService).setAlias("lbl.fsb", "free_spins_bonus");
    Services.get(TranslationsService).setAlias("lbl.jpb", "jackpot_pick");
    Services.get(TranslationsService).setAlias("lbl.ptt", "help_text");
    Services.get(TranslationsService).setAlias("gam.sub", "substitutes_for_all_symbols");
    Services.get(TranslationsService).setAlias("all.pa1", "all_pays_gold");
    Services.get(TranslationsService).setAlias("all.pa2", "all_pays_gold");
    Services.get(TranslationsService).setAlias("btn.aut", "autoplay");
    Services.get(TranslationsService).setAlias("btn.sto", "stop");
    Services.get(TranslationsService).setAlias("big.win", "big_win");
    Services.get(TranslationsService).setAlias("bet.men", "menu");
    Services.get(TranslationsService).setAlias("bet.bet", "bet_caps");
    Services.get(TranslationsService).setAlias("bet.mul", "multiplier");
    Services.get(TranslationsService).setAlias("bet.max", "max_bet");
    Services.get(TranslationsService).setAlias("bet.tot", "total_bet");
    Services.get(TranslationsService).setAlias("bet.low", "bet");
    Services.get(TranslationsService).setAlias("bet.cre", "credits");
    Services.get(TranslationsService).setAlias("bet.win", "win");
    Services.get(TranslationsService).setAlias("bet.bon", "bonus_win");
    Services.get(TranslationsService).setAlias("bet.fre", "free_spins");
    Services.get(TranslationsService).setAlias("alt.ok", "ok");
    Services.get(TranslationsService).setAlias("alt.yes", "yes");
    Services.get(TranslationsService).setAlias("alt.no", "no");
    Services.get(TranslationsService).setAlias("jak.gra", "grand");
    Services.get(TranslationsService).setAlias("jak.maj", "major");
    Services.get(TranslationsService).setAlias("jak.mii", "mini");
    Services.get(TranslationsService).setAlias("jak.mio", "minor");
    Services.get(TranslationsService).setAlias("fre.awa", "10_freespins_awarded");
    Services.get(TranslationsService).setAlias("fs.rtr", "x_more_freespins_awarded");
    Services.get(TranslationsService).setAlias("fs.wsu", "you_won_x_credits");
    Services.get(TranslationsService).setAlias("bet.bal", "balance");
    Services.get(TranslationsService).setAlias("tot.cap", "total_bet_caps");
    Services.get(TranslationsService).setAlias("lbl.cfs", "freespins_selection_one");
    Services.get(TranslationsService).setAlias("lbl.cfb", "freespins_selection_two");
    Services.get(TranslationsService).setAlias("lbl.jpk", "jackpot_pick_bonus");
    Services.get(TranslationsService).setAlias("btn.hel", "help");
    Services.get(TranslationsService).setAlias("way.243", "ways_to_wins_243");
    Services.get(TranslationsService).setAlias("way.102", "ways_to_wins_1024");
    Services.get(TranslationsService).setAlias("way.312", "ways_to_wins_3125");
    Services.get(TranslationsService).setAlias("lbl.c1f", "choose_one");
    Services.get(TranslationsService).setAlias("lbl.f15", "fifteen_freespins_select");
    Services.get(TranslationsService).setAlias("lbl.f10", "ten_freespins_select");
    Services.get(TranslationsService).setAlias("lbl.fs5", "five_freespins_select");
    Services.get(TranslationsService).setAlias("btn.acc", "account");
    Services.get(TranslationsService).setAlias("btn.dep", "deposit");
    Services.get(TranslationsService).setAlias("pre.ijb", "preloader_imperial");
    Services.get(TranslationsService).setAlias("pre.hwb", "preloader_holdwin");
    Services.get(TranslationsService).setAlias("pre.fsb", "preloader_freespins");
    Services.get(TranslationsService).setAlias("pre.50l", "exp_feature");
    Services.get(TranslationsService).setAlias("lbl.hwb", "hold_win_bonus");
    Services.get(TranslationsService).setAlias("lbl.ijb", "imperial_bonus");
    Services.get(TranslationsService).setAlias("rules.gam", "disclaimer");
    Services.get(TranslationsService).setAlias("rules.ver", "game_info_1");
    Services.get(TranslationsService).setAlias("rules.dat", "game_info_2");
    Services.get(TranslationsService).setAlias("rules.rtp", "game_info_3");
    Services.get(TranslationsService).setAlias("lbl.plw", "payline");
    Services.get(TranslationsService).setAlias("fot.fre", "free_spins_won");
    Services.get(TranslationsService).setAlias("mal.voi", "malfunction");
    Services.get(TranslationsService).setAlias("bal.cap", gameiomModel.shouldDisplayCredits() ? "credits_caps" : "balance_caps");
    Services.get(TranslationsService).setAlias("bet.men", "bet_menu_title");


    if (gameiomModel.displayCurrency) {
        Services.get(TranslationsService).setAlias("fot.lin", "line_win_currency");
    } else {
        Services.get(TranslationsService).setAlias("fot.lin", "line_win");
    }

    // TODO: This section now done via translation aliasing, but we still need to possibly redesign
    //       the menu so that we can support the different UIDenomDisplayType bet menus.

    if (gameiomModel.denomDisplay === UIDenomDisplayType.multiplier) {
        Services.get(TranslationsService).setAlias("bet.den", "multiplier_caps");
    } else {
        Services.get(TranslationsService).setAlias("bet.den", "denom");
    }

    if (gameiomModel.betSettings === UIBetSettingsType.totalBet) {
        Services.get(TranslationsService).setAlias("bet.one", "total_bet_caps");
    } 
    else if (gameiomModel.betSettings === UIBetSettingsType.denom) {
        Services.get(TranslationsService).setAlias("bet.one", "denom");
        Services.get(TranslationsService).setAlias("bet.two", "multiplier_caps");
    }
    else if(gameiomModel.betSettings === UIBetSettingsType.lines) {
        Services.get(TranslationsService).setAlias("bet.one", "bet_per_line");
        Services.get(TranslationsService).setAlias("bet.two", "bet_caps");
    }
    else {
        throw new Error("betSettings param is not configured!");
    }
}
